export const API_URL = 'https://sts-bresso-2024-api-721567546007.europe-west1.run.app/register';
export const TOOLPRESS_API = "https://api-tool-press-yn26wrnl4q-ey.a.run.app";